/**
 * Every business and legal value the Privacy Policy and Terms of Use depend on.
 *
 * Values wrapped in square brackets are UNRESOLVED and must be settled by the
 * business and reviewed by counsel before these pages go to production. They
 * render as visibly marked tokens so they cannot be missed in review. Replace
 * the string here and the token disappears everywhere it was used.
 *
 * Nothing in this file should be guessed. An empty decision is safer in public
 * than an invented one.
 */
import { contactEmail } from './links';

export const legalConfig = {
  // --- Entity and contact -------------------------------------------------
  legalEntity: '[SHARESHUTTER LEGAL ENTITY]',
  mailingAddress: '[MAILING ADDRESS]',
  privacyEmail: '[PRIVACY EMAIL]',
  // The address the site's Contact link opens, kept in links.js so the footer
  // and these documents can never point at two different inboxes.
  supportEmail: contactEmail,
  copyrightEmail: '[COPYRIGHT AGENT EMAIL]',

  // --- Jurisdiction -------------------------------------------------------
  governingLaw: '[GOVERNING LAW]',
  venue: '[VENUE]',

  // Leave as null unless the business deliberately adopts binding arbitration
  // after legal advice. A null value renders a plain informal-resolution
  // clause instead, which is the conservative default.
  arbitration: null,

  // --- Commercial terms ---------------------------------------------------
  // Counsel must decide whether a cap is stated and what it is. Null renders
  // the clause without a numeric cap.
  liabilityCap: null,
  refundPolicy: '[REFUND POLICY]',
  minimumAge: '[MINIMUM AGE]',

};

/**
 * Change a date ONLY when the corresponding document's wording changes. These
 * are deliberately hardcoded rather than derived from the build so that a
 * redeploy does not silently claim the terms were revised.
 */
export const legalDates = {
  privacy: 'August 15, 2026',
  terms: 'August 15, 2026',
};

export const legalRoutes = {
  privacy: '/privacy',
  terms: '/terms',
  home: '/',
};

/** True when a config value is still an unresolved placeholder token. */
export const isPlaceholder = (value) =>
  typeof value === 'string' && value.startsWith('[') && value.endsWith(']');

export default legalConfig;
